import { _ModalConfirmacion } from "./ModalConfirmacion";
import { ModalThingsUtil as util } from "./Utils";

type IModalThingsBase1 = util.IModalThingsBase1
import IModalThings = util.IModalThings

export interface IModalInfoDataListConfig<TData> extends Pick<IModalThingsBase1, "Title" | "LangModuleKeyInContext"> {
    /** Texto que se muestra como mensaje principal en el modal @example "Errores obtenidos:" */
    InfoText: string;
    DataList: TData[];
    /** @default 400 px */
    Width?: number;
    OnStepItemData?: (content: TSelectionHTML<"div">, itemData: TData) => void;
    OnAccept?: (modalThings: IModalThings) => void;
    OnClose?: () => void;
}
/**
 * Muestra una lista de elementos X a manera de resumen básico
 *
 * * Por defecto solo muestra el boton de "Aceptar" (BtnRight)
 * @param config
 */
export function _ModalInfoDataList<TData>(config: IModalInfoDataListConfig<TData>): IModalThings<any> {
    return _ModalConfirmacion({
        Title: config.Title,
        Message: config.InfoText,
        LangModuleKeyInContext: config.LangModuleKeyInContext,
        Width: (config.Width || 400),
        OnAccept: (modalThings) => {
            //modalThings.Modal.met_Ocultar();

            if (config.OnAccept) {
                config.OnAccept(modalThings);
            }
        },
        OnClose: config.OnClose,
        DrawContent: (content, modalThings) => {
            modalThings.BtnLeft.classed("hide_transparent", false);
            modalThings.BtnLeft.classed("hide", true);

            content.classed("modal_details_1", true);

            let contDataList = content.append("div")
                .attr("class", "datalist")
                .style("column-gap", "5px")
            config.DataList.forEach(d => {
                let itemC = contDataList.append("div");
                let content = itemC.append("div")
                    .style("border-left", "1px solid var(--color_primary4)")
                    .style("padding-left", "var(--padding1)");
                if (config.OnStepItemData) {
                    config.OnStepItemData(content, d);
                } else {
                    content.html(String(d));
                }
            })
        },
    })
}